import React, { useEffect, useState } from "react";

import { Outlet, useLocation } from "react-router-dom";

import Navbar from "../../component/Navbar/Navbar";
import Footer from "../../component/Footer/Footer";
import { ScrollToTop } from "../../../utils/Utils";
import HiringModal from "../../component/Modals/HiringModal";
import HrContactLauncher from "./HrContact";
import { submitHrContactRequest } from "./hrContact.api";

const JOB_CONNECTOR_PATH = "/careers/job-connecter-bootcamp";

const Layout = () => {

  const location = useLocation();
  const isJobConnectorPage = location.pathname.replace(/\/$/, "") === JOB_CONNECTOR_PATH;
  let [isCLickClicked,setisCLickClicked] = useState(false)
  const linkClicked = () => {
    setisCLickClicked(!isCLickClicked)
  };

  return (
    <div>
      <ScrollToTop isCLickClicked={isCLickClicked} />
      <div className="app">
        <Navbar linkClicked = {linkClicked}  />
        <main className="bg-[#f8fafc]">
          <Outlet context={{ linkClicked }} />
        </main>
        <Footer linkClicked = {linkClicked}/>
        {isJobConnectorPage && (
          <HrContactLauncher
            courseLabel="Job Connector Bootcamp"
            submitContact={submitHrContactRequest}
          />
        )}
        {/* <HiringModal /> */}
      </div>
    </div>
  );
};

export default Layout;
